import {IActionBase} from "./IActionBase";
import React, {Component} from "react";
import {ActionsManager} from "./actionsManager";
import {dataUtils} from "../js/dataUtils";
import {utils_ui} from "../utils/utils_ui";
import {store} from "../../redux/storeConfig/store";
import {callPostService, callPostServiceByUrl} from "../services/api_service";
import {webResponseObject} from "../services/webResponseResponse";
import { applyooConfig } from "../js/applyooConfig";
import {confirmationParams} from "../infrastructure/project-frame-container/globalModals/confirmationModal";
import {sendApplyooComponentsNotification} from "../infrastructure/useApplyooComponent";
import UI_ApplyooIcon from "../components/componentParts/UI_ApplyooIcon";


export class ServerAction_CallGeneralAction extends Component implements IActionBase {
    actionCode = "ServerAction_CallGeneralAction";
    actionName = "ServerAction_CallGeneralAction";

    Execute = (prmActionParameters: any, prmActionsManager: ActionsManager, prmElementObj?: any) => {

        if (!!prmActionParameters.LstActionsBeforeUpload && prmActionParameters.LstActionsBeforeUpload.length > 0) {
            prmActionsManager.executeActions(prmActionParameters.LstActionsBeforeUpload, prmElementObj?.ElementObj)
        }

        if (prmActionParameters.isUploadFileBeforeCallingServerAction) {

            const params: any = {
                callbackFunction: (prmResponseFiles:any)=>this.browseFiles_Callback(prmResponseFiles , prmActionParameters, prmActionsManager),
                isSingleFile: true,
                command: 'browseFiles'
            }
            sendApplyooComponentsNotification("ApplyooGlobal", "ApplyooBrowseFiles", params)

            
        } else {
            this.callServerAction(prmActionParameters,prmActionsManager, prmElementObj);
        }
    }

    browseFiles_Callback = (prmResponseFiles:any ,prmActionParameters:any, prmActionsManager:any) =>{
        //TODO: add UploadedFileToken to parameters
        //TODO: call callServerAction
        if(!prmActionParameters.arrActionParams){
            prmActionParameters.arrActionParams = []
        }
        prmActionParameters.arrActionParams.push({ParamName: 'UploadedFileToken', value: prmResponseFiles.RuntimeToken})
        prmActionParameters.callbackFunction = null

        this.callServerAction( prmActionParameters ,prmActionsManager);
    }

    callServerAction = (prmActionParameters: any, prmActionsManager: ActionsManager, prmElementObj?: any, prmFileObj?: any) => {
        //let dicFiltersValues = APPLYOO.runtimeUtils.getDicFilterValues(prmActionParameters.QueryName);
        let currActionCode = prmActionParameters.ActionCode;
        let currProjectID = store.getState().store_ProjectData.projectID
        //let storedProjectID = APPLYOO.runtimeUtils.scopeObj.selectedProjectID; //prmActionParameters.StoredProject;

        // if (prmActionParameters.StoredProject == "applyoo") {
        //     storedProjectID = ESLNS.jsConfig.c_applyooProjectID;
        // }

        let paramsDic:any = {};

        if (!!prmActionParameters.arrActionParams && prmActionParameters.arrActionParams.length > 0) {

            for (let ind01 = 0; ind01 < prmActionParameters.arrActionParams.length; ind01++) {
                let currParam = prmActionParameters.arrActionParams[ind01];
                let currDataBindStr = "";
                let currParamValue = "";

                switch (currParam.SourceType) {
                    case "element":
                        let elementObj = dataUtils.getElementByClientID(currParam.ParamValue);
                        currDataBindStr = elementObj.DataBindStr;
                        break;

                    case "dataBind":
                        currDataBindStr = currParam.ParamValue;
                        break;

                    case "value":
                        currParamValue = utils_ui.getRelatedParamsForValue(currParam.ParamValue); //currParam.ParamValue;
                        break;
                    default:
                        currParamValue = currParam.value;

                }

                if (!!currDataBindStr) {
                    if (currDataBindStr.startsWith('Temp.@SelectedRow.') && !!prmElementObj?.DataObj) {
                        currParamValue = dataUtils.getNestedJsonValue(prmElementObj.DataObj,currDataBindStr.substring('Temp.@SelectedRow.'.length));
                    }
                    else {
                        currParamValue = utils_ui.getDataItem(currDataBindStr);
                    }

                    if (!!currParamValue
                        && !dataUtils.isNativeProperty(currParamValue)) {
                        currParamValue = JSON.stringify(currParamValue);
                    }
                }
               

                paramsDic[currParam.ParamName] = currParamValue;
            }
        }

        if (!!prmFileObj) {
            paramsDic["Filename"] = prmFileObj.FileItem.FileName;
        }

        if(!!prmElementObj){
            paramsDic["UploadedFileToken"] = prmElementObj["UploadedFileToken"]
        }

        let params = {
            prmProjectID: currProjectID,
            prmDeveloperKey: currActionCode,
            prmParamsDic: paramsDic,
        };

        callPostService("Asset_ExecuteServerAction",params).then((prmResponse:webResponseObject) => {
            if (!!prmResponse?.reponseObj) {
                return executeServerAction_Callback(prmResponse);
            }
        })

        function executeServerAction_Callback(prmResponse:any) {

            //clearErrors(paramsObj);

            let IsValidToBool = dataUtils.convertValueToType(prmResponse?.reponseObj?.IsValid, 'boolean');
            //if (prmResponse.hasOwnProperty('IsValid')) {
                if (!!IsValidToBool) {

                    if (prmResponse?.reponseObj?.hasOwnProperty('IsDownloadFile')
                        && prmResponse?.reponseObj?.hasOwnProperty('OutputFileUrl')) {
                        let IsDownloadFile = dataUtils.convertValueToType(prmResponse?.reponseObj?.IsDownloadFile, 'boolean');

                        if (!!IsDownloadFile) {
                            //window.open('https://localhost:5001https://localhost:5001/api/getfile?prmProjectID=1080&prmPageID=0&prmFileID=0&prmRuntimeToken=1068bf06-4929-4e2f-872a-33fa8919f57f&prmActionType=download','_blank')
                            if (prmResponse?.reponseObj?.OutputFileUrl?.indexOf('=download') > -1
                                        && prmResponse?.reponseObj.OutputFileUrl.indexOf('/getfile?') > -1) {
                                window.open(`${prmResponse?.reponseObj.OutputFileUrl}`, "_blank");
                            }
                            else {
                                const fileURL = `${utils_ui.getBaseFilesUrl()}${prmResponse?.reponseObj.OutputFileUrl}`;
                                window.location.href = fileURL;
                            }

                            // window.location.href = prmResponse?.reponseObj?.OutputFileUrl;
                        }
                    }

                    if (!!prmActionParameters.arrDataAfterSuccess
                        && prmActionParameters.arrDataAfterSuccess.length > 0) {
                        setDataByResponseKeys(prmActionParameters.arrDataAfterSuccess, prmResponse?.reponseObj);
                    }

                    let IsContainWarnings = dataUtils.convertValueToType(prmResponse?.reponseObj?.IsContainWarnings, 'boolean');
                    if (!!IsContainWarnings) {
                        if (!!prmActionParameters.arrDataAfterContainWarnings
                            && prmActionParameters.arrDataAfterContainWarnings.length > 0) {
                            setDataByResponseKeys(prmActionParameters.arrDataAfterContainWarnings, prmResponse?.reponseObj);
                        }

                        prmActionsManager.executeActions(prmActionParameters?.LstActionsAfterActionContainWarnings, prmElementObj?.ElementObj)
                    } else {
                        prmActionsManager.executeActions(prmActionParameters?.LstActionsAfterActionSucceed, prmElementObj?.ElementObj)
                    }
                } else {
                    if (!!prmActionParameters.arrDataAfterFail
                        && prmActionParameters.arrDataAfterFail.length > 0) {
                        setDataByResponseKeys(prmActionParameters.arrDataAfterFail, prmResponse?.reponseObj);
                    }

                    prmActionsManager?.executeActions(prmActionParameters?.LstActionsAfterActionFail, prmElementObj?.ElementObj)

                    if (prmResponse?.reponseObj?.hasOwnProperty('ErrorMessage')) {
                        alert(prmResponse?.reponseObj?.ErrorMessage);
                    }

                    if (prmResponse?.reponseObj?.hasOwnProperty('ViewValidationErrors_Messages')) {
                        let messageTitle = utils_ui.getLanguageTitle(prmResponse?.reponseObj?.ViewValidationErrors_Title)

                        let innerJsx =   <div className='transaction-validation-errors-wrapper bg-light-danger p-1 rounded'>
                            <div className='font-medium-2 font-weight-bold py-25'>
                                {utils_ui.getLanguageTitle('Title_Errors')}
                            </div>

                            <div className='flex-column gap-25 d-flex py-1'>
                                {prmResponse?.reponseObj?.ViewValidationErrors_Messages?.split(',')?.map((prmError:any) => {
                                    return <div className='d-flex gap-50'>
                                        <UI_ApplyooIcon iconStr='circle' className='font-small-1' />
                                        <div>{utils_ui.getLanguageTitle(prmError)}</div>
                                    </div>
                                })}
                            </div>
                        </div>

                        const params: confirmationParams = {
                            ModalParameters: {
                                innerJsx: innerJsx,
                                ModalClassNames: 'modal-lg2',
                                MessageTitle: messageTitle,
                                DisplayMessage: ' ',
                                CancelBtnText: utils_ui.getLanguageTitle("Title_Close")
                            },
                            command: 'openConfirmationModal'
                        }
                        sendApplyooComponentsNotification("ApplyooGlobal", "ConfirmationModal", params)

                    }

                    // if (prmResponse?.reponseObj?.hasOwnProperty('ViewValidationErrors_DataRows')) {
                    // }
                }
            //}

            if (!!prmActionParameters?.callbackFunction){
                prmActionParameters?.callbackFunction(prmResponse?.reponseObj)
            }
        }

        function setDataByResponseKeys(prmArrKeys:any, prmResponse:any) {

            for (let ind01 = 0; ind01 < prmArrKeys.length; ind01++) {
                let currItem = prmArrKeys[ind01];
                let dataBindStr = "";
                let currData = null;
                let currElementObj = null;

                if (currItem.TargetType.toString().toLowerCase() == "element") {
                    currElementObj = dataUtils.getElementByClientID(currItem.ElementIdentifier);

                    if (!!currElementObj) {
                        dataBindStr = currElementObj?.DataBindStr;
                    }
                } else if (currItem.TargetType.toString().toLowerCase() == "databind") {
                    dataBindStr = currItem.TargetDataBindStr;
                }


                if (prmResponse.hasOwnProperty(currItem.DataKeyName)
                    && !!dataBindStr) {
                    if (currItem.DataType == "array" || currItem.DataType == "object") {
                        currData = JSON.parse(prmResponse[currItem.DataKeyName]);

                    } else if (currItem.DataType == "number") {
                        currData = dataUtils.convertValueToType(prmResponse[currItem.DataKeyName], currItem.DataType);

                    } else if (currItem.DataType == "string") {
                        currData = prmResponse[currItem.DataKeyName];

                    } else if (currItem.DataType == "boolean") {
                        currData = prmResponse[currItem.DataKeyName] == "true";
                    }

                    utils_ui.setDataItem(dataBindStr, currData);

                    // let arrRelatedElements = APPLYOO.selectedPage.getAllElementsByDataBindStr(dataBindStr);
                    //
                    // if (!!arrRelatedElements && arrRelatedElements.length > 0) {
                    //     for (let ind02 = 0; ind02 < arrRelatedElements.length; ind02++) {
                    //         let relatedElementObj = arrRelatedElements[ind02];
                    //         APPLYOO.runtimeUtils.fireElementEvent_refreshData(relatedElementObj);
                    //     }
                    // }

                }
            }
        }

        function clearErrors(prmParamsObj:any) {

            if (!!prmParamsObj
                && !!prmParamsObj.ValidationErrorsElementTagCode) {

                let arrElements = dataUtils.getElementsByElementTag(prmParamsObj.ValidationErrorsElementTagCode);

                for (let ind01 = 0; ind01 < arrElements.length; ind01++) {

                    let currElement = arrElements[ind01];

                    utils_ui.setDataItem(currElement.DataBindStr, [],true);
                    //APPLYOO.runtimeUtils.fireElementEvent_refreshData(currElement);


                    currElement.IsVisible = false;
                }
            }
        }

    }
    
  
}